import { useEffect } from "react";
import { useSelector } from "react-redux";

interface Dictation {
  active?: boolean;
  key?: string;
  text?: string;
}

export function useDictationEffect(
  keyArray: string[],
  callback: (dictation: Dictation) => void
) {
  const dictation = useSelector(({ sys }) => sys.dictation);

  useEffect(() => {
    if (
      dictation?.key &&
      !dictation?.active &&
      keyArray.includes(dictation.key)
    ) {
      callback(dictation);
    }
  }, [dictation?.active]);
}
